/* eslint-disable */

import { useMemo, useState } from "react";

export const useColumnHeaderSelector = allHeaders => {
  const getInitialHeaders = () =>
    allHeaders.map(header => ({ ...header, headerVisible: true }));
  const [headers, setHeaders] = useState(getInitialHeaders());

  const toggleHeaderVisibility = key => {
    setHeaders(prev =>
      prev.map(header =>
        header.key === key
          ? { ...header, headerVisible: !header.headerVisible }
          : header
      )
    );
  };

  const columns = useMemo(() => {
    const filterHeader = condition => {
      const isWidthRemove =
        headers?.filter(header => header.headerVisible).length <
        headers?.length - 1;
      let filterHeader = headers.filter(
        header => header.isHidable === null || !header.isHidable
      );
      filterHeader = isWidthRemove
        ? headers.map(({ width, ...rest }) => rest)
        : filterHeader;
      return filterHeader
        ?.filter(header => header.headerVisible === condition)
        .map(({ headerVisible, ...rest }) => rest);
    };

    return {
      selected: filterHeader(true),
      unSelected: filterHeader(false),
    };
  }, [headers]);

  const toggleVisibility = key => toggleHeaderVisibility(key);

  return { columns, toggleVisibility };
};
